import PageTransition from "@/components/site/PageTransition";
import PageHero from "@/components/site/PageHero";
import GlobalPresence from "@/components/site/GlobalPresence";

export default function GlobalPage() {
    return (
        <PageTransition>
            <PageHero
                crumbs={[{ label: "Home", to: "/" }, { label: "Global" }]}
                eyebrow="Global · Creative Reach"
                title="From Bangladesh, to the {gold:world}."
                intro="A studio base in Bangladesh, with brand work flowing to clients across every continent."
                tone="cool"
            />
            <GlobalPresence />
        </PageTransition>
    );
}
